<template>
  <div class="contents shinsei">
    <h2>申請</h2>

    <div class="container">
      <template v-if="isLoading">
        <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
      </template>
      <template v-else>
        <div class="container-info">
          <div class="container-base">
            <!-- <p class="danger-text">
              雇用契約ID：{{ form.koyou_keiyaku_id }}<br>
              就業場所ID：{{ form.mst_syuugyou_basyo_id }}<br>
              申請雇用契約時間：{{ form.shinsei_koyou_keiyaku_time }}
            </p> -->

            <!-- 基本情報 -->
            <div>
              <div class="col-item"><b class="title">申請日</b><span>{{ date }}</span></div>
              <div class="col-item"><b class="title">社員番号</b><span>{{ user?.staff_code }}</span></div>
              <div class="col-item"><b class="title">氏名</b><span>{{ user?.staff_name }}</span></div>
            </div>

            <!-- 各種申請 -->
            <div class="maininfo">
              <component :is="type" :shinseiDate="date" ref="child" />
            </div>

          </div>
        </div>

        <div class="button-container">
          <p class="prev-page">
            <a @click="router.go(-1)">戻る
            </a>
          </p>
          <p class="btn-temporary-save">
            <button type="button" @click="save" :disabled="isLoading">
              <template v-if="isExec">
                <i class="fa-solid fa-spinner fa-spin-pulse"></i>処理中…
              </template>
              <template v-else>
                <i class="fa-solid fa-floppy-disk"></i>申請
              </template>
            </button>
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { useInit } from "@/composable/shinsei/typelist/init";
import { useForm } from "@/composable/shinsei/typelist/form";
import { dateFormat } from "@/filters/common";
import { useRouter } from 'vue-router';
import { RouterConst } from "@/const/Router";
import HayabanOsoban from "./parts/HayabanOsoban.vue";
import Koukyuu from "./parts/Koukyuu.vue";
import OptionConst from "@/const/Option";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { useConfigStore } from "@/store/config";

export default defineComponent({
  setup() {
    // 初期化
    const { type } = useInit()
    const { user, getUser } = useForm()
    const router = useRouter()
    const { isLoading } = useSyuugyouBasyoInit()
    const configStore = useConfigStore()

    const child = ref()
    const isExec = ref(false)

    const targetDate = ref();

    onMounted(() => {
      getUser()
    })

    const date = computed(() => {
      return configStore.sysDatetime?.toLocaleDateString()
    })

    const save = () => {
      child.value.onSave()
    }


    return {
      isLoading,
      dateFormat,
      RouterConst,
      OptionConst,
      child,
      router,
      save,
      isExec,
      type,
      user,
      date,
      targetDate,
    };
  },
  components: {
    hayaban_osoban: HayabanOsoban,
    koukyuu: Koukyuu,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
